import { render, staticRenderFns } from "./swiper-pagination.vue?vue&type=template&id=6555003a&scoped=true"
import script from "./swiper-pagination.vue?vue&type=script&lang=js"
export * from "./swiper-pagination.vue?vue&type=script&lang=js"
import style0 from "./swiper-pagination.vue?vue&type=style&index=0&id=6555003a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6555003a",
  null
  
)

export default component.exports